<!-- @component Adds Open Graph <meta> tags to page. -->
<script lang="ts">
  // The fallback og:title and og:description values are intentionally kept

  interface Props {
    title?: string;
    description?: string;
    imageUrl?: string;
  }

  let {
    // short to avoid being repetitive when linking dashboard pages.
    title = "Modal",
    description = "AI infrastructure that developers love.",
    imageUrl = "https://modal.com/assets/social-image-4.jpg",
  }: Props = $props();
</script>

<svelte:head>
  <!-- HTML Meta tags -->
  <meta name="description" content={description} />

  <!-- Opengraph -->
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Modal" />
  <meta property="og:title" content={title} />
  <meta property="og:description" content={description} />
  {#if imageUrl}
    <meta property="og:image" content={imageUrl} />
  {/if}

  <!-- Twitter -->
  <meta name="twitter:card" content="summary_large_image" />
</svelte:head>
